<template>
  <div class="wisdom-expert main">
      <div class="sort-navigate flex-layout">
          <span class="sort-name">职称：</span>
          <ul class="sort-ul">
            <li v-for="(item,index) in navigate" 
                :key="index"
                :class="{'active':active === index}"
                @click="handleClick(item,index)"
                class="sort-item csp">
                {{item.name}}
            </li>
          </ul>
          <div class="sort-search">
            <el-input
              size="mini"
              placeholder="请输入专家姓名"
              suffix-icon="el-icon-search"
              v-model="search"
              @change="searchExpert">
            </el-input>
          </div>
      </div>
      <div v-if="teamList.length > 0 && teamList">
        <div class="expert-part">
          <div class="expert-item flex-layout" v-for="(item,index) in teamList" :key="index">
              <div class="expert-avatar-wrapper">
                <img :src="downloadURL + item.avatar || 'xxx'" alt="" class="expert-avatar" :onerror="handleDefualtAvatar(item.sex)">
              </div>
              <div class="info">
                  <h4 class="expert-name">{{item.name}}</h4>
                  <span class="expert-title">{{item.title}}</span>
                  <p class="introduce wes-3">{{item.introduce}}</p>
              </div>
          </div>
        </div>
        <div class="pagination-part">
          <pagination v-show="pages.total > 0" 
                      :total="pages.total" 
                      :page.sync="pages.currentPage" 
                      :limit.sync="pages.pageSize"
                      :background="true"
                      @pagination="handlePageChange">
          </pagination>
        </div>
      </div>
      
      <!-- 无课节-->
      <div class="nothing-box flex-align" v-else>
        <div class="nothing-wrap">
          <img src="@/assets/wisdom/nothing.png" alt="">
          <p>暂无内容</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props:{
    columnId:{
      type:Number
    }
  },
  data() {
    return {
      navigate:[], //分类导航
      search:'', //搜索课程
      active:0, //当前被选中的导航
      currentTitleId:null, //当前被选中的职称ID
      teamList:[], //专家列表
      pages:{ //分页
        currentPage: 1,
        pageSize:5,
        total:10,
      },
    }
  },
  watch: {
    columnId: {
      handler(newVal,oldVal) {
        if(!newVal) return
        this.getExpertList();
      },
      // immediate: true
    }
  },
  methods: {
    // 默认头像
    handleDefualtAvatar(sex) {
      if(sex == 1) {
        return 'this.src="' + require("../../../assets/wisdom/woman.png") + '"'
      } else {
        return 'this.src="' + require("../../../assets/wisdom/man.png") + '"'
      }
    },
    // 切换学科
    handleClick(item,index) {
      this.active = index;
      this.currentTitleId = item.id
      this.pages.currentPage = 1;
      this.getExpertList();
    },
    // 切换分页
    handlePageChange(data){
      this.pages.currentPage = data.pageIndex
      this.pages.pageSize = data.pageSize
      this.getExpertList();
    },
    // 按名称搜索专家
    searchExpert(val){
      console.log(val);
      this.pages.currentPage = 1;
      this.getExpertList();
    },
    // 获取职称列表
    async getTitleList(){
      let resData = await Api.Wisdom.getTitleList()
      // console.log(resData)
      this.navigate = resData.data
      this.navigate.unshift({
         id: null,
         name: "全部"
      })
      this.currentTitleId = this.navigate[0].id
      this.getExpertList();
    },
    // 获取专家数据
    async getExpertList() {
      if(!this.columnId)  return;
      let params = {
        page:this.pages.currentPage,
        limit:this.pages.pageSize,
        titleId:this.currentTitleId,
        columnId: this.columnId,
        projectId: Number(sessionStorage.getItem('projectID'))
      }
      params.name = this.search ? this.search : null;
      let resData = await Api.Wisdom.getExpertList(params);
      // console.log(resData);
      this.teamList = resData.data.list
      this.pages.total = resData.data.totalCount
    }
  },
  activated() {
    this.getTitleList();
  },
  mounted() {
    this.getTitleList();
  }
}
</script>

<style lang="less" scoped>
  @import "./less/wisdom_subject.less";

</style>